export const Genders = Object.freeze({
    female: { value: "female", label: "Female" },
    male: { value: "male", label: "Male" },

    getAllOptions() {
        let options = [];

        Object.keys(this).forEach((key) => {
            if (typeof this[key] !== "object") {
                return;
            }

            options.push(this[key]);
        });

        return options;
    },
});
